import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/setmeal/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/setmeal/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/setmeal/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/setmeal/save', params, options);

export const update = (params, options) =>
  request.post('/api/park/setmeal/update', params, options);

export const setmealSelections = (params, options) =>
  request.post('/api/park/setmeal/selections', qs.stringify(params), options);
